import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getRepostsListDetails } from '../../Services/ApiServices';
import toast from 'react-hot-toast';
import back from "../../Assets/Image/admin/back.png";
import nodata from "../../Assets/Image/admin/nodata.png";
import { Bars } from "react-loader-spinner";
import { IMG_URL } from '../../Services/Api';

const ReportDetails = () => {
    const [pageNo, setPageNo] = useState(1);
    const [totalPage, setTotalPage] = useState("1");
    const [getDetails, setGetDetails] = useState([]);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();    

    const handlExcerciseList = () => {
        setLoader(true);
        let obj = { page: pageNo, user_id: id };

        getRepostsListDetails(obj)
            .then((res) => {
                setTotalPage(res?.data?.totalPages);
                setLoader(false);
                setGetDetails(res?.data?.data || []);
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/login");
                } else {
                    toast.error(err?.response?.data?.message);
                }
                setLoader(false);
            });
    };

    useEffect(() => {
        handlExcerciseList();
    }, [pageNo]);

    const renderPaginationButtonss = () => {
        const maxPagesToShow = 3;
        const buttons = [];
        const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={
                        i === pageNo
                            ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
                            : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
                    }
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPage) {
            setPageNo(page);
        }
    };

    return (
        <>
            <div className="grid grid-cols-12 md:m-4 m-1 fontNew">
                {loader ? (
                    <div className="flex justify-center items-center col-span-12 h-[70vh]">
                        <Bars
                            height="35"
                            width="35"
                            color="#FF4433"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>
                ) : (
                    <>
                        {getDetails.length === 0 ? (
                            <div className="col-span-12 h-[50vh] justify-center flex items-center">
                                <img src={nodata} className="w-28" alt="No data" />
                            </div>
                        ) : (
                            <>
                                <div className="col-span-12 gap-4">
                                    <div className="p-4 bg-white rounded-xl">
                                        <div className="mb-6 flex items-center gap-x-5">
                                            <button className="text-xl">
                                                <img
                                                    src={back}
                                                    onClick={() => navigate(-1)}
                                                    className="w-4"
                                                    alt=""
                                                />
                                            </button>
                                            <h1 className="text-xl font-medium">Go Back</h1>
                                        </div>

                                        {getDetails?.map((user, idx) => (
                                            <div key={idx}>
                                                <div className="flex items-center gap-4 mb-6">
                                                    <img
                                                        src={`${IMG_URL + user.profile_image}`}
                                                        alt={`${user.firstname} ${user.lastname}`}
                                                        className="w-20 h-20 rounded-full object-cover"
                                                    />
                                                    <div>
                                                        <h2 className="font-semibold text-lg">
                                                            {`${user.firstname} ${user.lastname}`}
                                                        </h2>
                                                        <p className="text-sm text-gray-500">{user.email_id}</p>
                                                    </div>
                                                </div>

                                                <h3 className="font-medium mb-3 text-lg">Reported By</h3>
                                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                    {user.reports_received.map((report, rIdx) => (
                                                        <div
                                                            key={rIdx}
                                                            className="border rounded-xl p-4 flex gap-4 items-start shadow-sm"
                                                        >
                                                            {report.reporter?.profile_image ? (
                                                                <img
                                                                    src={`${IMG_URL + report.reporter.profile_image}`}
                                                                    alt={`${report.reporter.firstname} ${report.reporter.lastname}`}
                                                                    className="w-12 h-12 rounded-full object-cover"
                                                                />
                                                            ) : (
                                                                <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center">
                                                                    <svg
                                                                        className="w-6 h-6 text-white"
                                                                        fill="currentColor"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                            <div>
                                                                <h4 className="font-semibold">
                                                                    {`${report.reporter.firstname} ${report.reporter.lastname}`}
                                                                </h4>
                                                                <p className="text-sm text-gray-500">
                                                                    {report.reporter.email_id}
                                                                </p>
                                                                <p className="text-sm mt-1">
                                                                    <span className="font-semibold">Reason:</span>{' '}
                                                                    <span className="text-gray-700">{report.reason}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="flex col-span-12 justify-end mt-4 items-center cursor-pointer">
                                            <p
                                                onClick={() => handlePageChange(pageNo - 1)}
                                                disabled={pageNo === 1}
                                            >
                                                Previous
                                            </p>
                                            <div className="flex items-center mx-6">
                                                {renderPaginationButtonss()}
                                            </div>
                                            <p
                                                onClick={() => handlePageChange(pageNo + 1)}
                                                disabled={pageNo === totalPage}
                                            >
                                                Next
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default ReportDetails;
